// extracted by mini-css-extract-plugin
module.exports = {"languageButton":"LanguageChange_languageButton__3hrOK","active":"LanguageChange_active__3--j5","languageChangeContainer":"LanguageChange_languageChangeContainer__3bJpw"};